import React, { useState, useEffect } from 'react';
import { Layout, Menu, Avatar, Dropdown, Typography } from 'antd';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { usePermissao, limparCachePermissoes } from '../hooks/usePermissao';
import api from '../services/api';
import { usePermissoes } from '../contexts/PermissoesContext';
import { CalendarOutlined, DashboardOutlined, TeamOutlined as UserTeamOutlined, TeamOutlined, FileTextOutlined, AuditOutlined, BarChartOutlined, UserOutlined, LogoutOutlined, SettingOutlined, FileWordOutlined, FileProtectOutlined, PlusOutlined, UserAddOutlined, MailOutlined, ShoppingOutlined, ShopOutlined } from '@ant-design/icons';

const { Sider, Header, Content } = Layout;
const { Text } = Typography;

function MainLayout() {
  const { temPermissao } = usePermissoes();
  const [logoMenu, setLogoMenu] = useState(null);
  useEffect(() => {
    api.get('/upload/logo-menu').then(r => { if (r.data.logo) setLogoMenu(r.data.logo); }).catch(() => {});
  }, []);
  const { menuVisivel } = usePermissao();
  const [collapsed, setCollapsed] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const usuario = JSON.parse(localStorage.getItem('usuario') || '{}');

  const todosMenuItems = [
    { key: '/dashboard', icon: <DashboardOutlined />, label: 'Dashboard', perm: 'dashboard' },
    { key: '/clientes', icon: <TeamOutlined />, label: 'Clientes', perm: 'clientes' },
    { key: '/produtos', icon: <ShoppingOutlined />, label: 'Produtos', perm: 'produtos' },
    { key: '/estoque', icon: <ShopOutlined />, label: 'Estoque', perm: 'estoque' },
    { key: '/leads', icon: <UserAddOutlined />, label: 'Leads', perm: 'leads' },
    { key: '/gestao', icon: <BarChartOutlined />, label: 'Gestão', perm: 'gestao' },
    { key: '/clientes?novo=true', icon: <PlusOutlined />, label: 'Novo Cliente', perm: 'clientes' },
    { key: '/propostas', icon: <FileTextOutlined />, label: 'Propostas', perm: 'propostas' },
    { key: '/laudos', icon: <AuditOutlined />, label: 'Laudos', perm: 'laudos' },
    { key: '/fiscal', icon: <FileProtectOutlined />, label: 'Fiscal', perm: 'nfse' },
    { key: '/agendamentos', icon: <CalendarOutlined />, label: 'OS/Agendamentos', perm: 'agendamentos' },
    { key: '/usuarios', icon: <UserTeamOutlined />, label: 'Usuários', perm: 'usuarios' },
    { key: '/relatorios', icon: <BarChartOutlined />, label: 'Relatórios', perm: 'relatorios' },
    { type: 'divider' },
    { key: '/templates', icon: <FileWordOutlined />, label: 'Templates', perm: 'templates' },
    { key: '/classificacao-nr13', icon: <FileProtectOutlined />, label: 'Classificação NR-13', perm: 'classificacao_nr13' },
    { key: '/envios-massa', icon: <MailOutlined />, label: 'Envios em Massa', perm: 'envio_massa' },
    { key: '/configuracoes', icon: <SettingOutlined />, label: 'Configura\u00e7\u00f5es', perm: 'configuracoes' },
  ];
  const menuItems = todosMenuItems.filter(item => menuVisivel(item.perm));

  const handleUserMenu = ({ key }) => {
    if (key === 'perfil') { navigate('/perfil'); return; }
    if (key === 'seguranca') { navigate('/seguranca'); return; }
    if (key === 'sair') {
      localStorage.removeItem('token'); limparCachePermissoes();
      localStorage.removeItem('usuario');
      navigate('/login');
    }
  };

  const userMenu = {
    items: [
      { key: 'perfil', icon: <UserOutlined />, label: 'Meu Perfil' },
      { key: 'seguranca', icon: <SettingOutlined />, label: 'Seguran\u00e7a' },
      { key: 'sair', icon: <LogoutOutlined />, label: 'Sair', danger: true }
    ],
    onClick: handleUserMenu
  };

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Sider collapsible collapsed={collapsed} onCollapse={setCollapsed} style={{ background: '#1a3c5e' }}>
        <div style={{ padding: '16px', textAlign: 'center' }}>
          {!collapsed && <img src={logoMenu || '/logo.png'} alt='Celum' style={{ height: 40, maxWidth: 150, objectFit: 'contain' }} />}
        </div>
        <Menu theme="dark" mode="inline" selectedKeys={[location.pathname]} style={{ background: '#1a3c5e' }} items={menuItems} onClick={({ key }) => navigate(key)} />
      </Sider>
      <Layout>
        <Header style={{ background: '#fff', padding: '0 24px', display: 'flex', justifyContent: 'flex-end', alignItems: 'center', boxShadow: '0 1px 4px rgba(0,0,0,0.1)' }}>
          <Dropdown menu={userMenu} placement="bottomRight">
            <div style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 8 }}>
              <Avatar icon={<UserOutlined />} style={{ background: '#1a3c5e' }} />
              <div style={{ lineHeight: 1.2 }}>
                <Text style={{ display: 'block' }}>{usuario.nome || 'Usuário'}</Text>
                <Text style={{ fontSize: 11, color: '#888', display: 'block' }}>{usuario.perfil || ''}</Text>
              </div>
            </div>
          </Dropdown>
        </Header>
        <Content style={{ margin: '24px', background: '#f0f2f5' }}>
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
}

export default MainLayout;
